import { render, staticRenderFns } from "./IssueTrackingTable.vue?vue&type=template&id=119c3a45"
import script from "./IssueTrackingTable.vue?vue&type=script&lang=js"
export * from "./IssueTrackingTable.vue?vue&type=script&lang=js"
import style0 from "./IssueTrackingTable.vue?vue&type=style&index=0&id=119c3a45&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports